import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFlag,
  faGavel,
  faHandFist,
  faMessageExclamation,
  faRepeat,
  faShieldExclamation,
  faSquareEllipsis,
  faThumbsDown,
} from "@fortawesome/sharp-regular-svg-icons";
import { styled } from "@mui/material/styles";

import { FileReportType } from "../../graphql/schema.graphql";

const FadedIcon = styled(FontAwesomeIcon)({
  opacity: 0.5,
});

type ReportType = {
  id: FileReportType;
  icon: JSX.Element;
  name: string;
};

export const ReportTypes: ReportType[] = [
  {
    id: "BAD_QUALITY",
    icon: <FadedIcon className="fa-fw" icon={faThumbsDown} />,
    name: "Bad Quality",
  },
  {
    id: "IP_INFRINGEMENT",
    icon: <FadedIcon className="fa-fw" icon={faGavel} />,
    name: "IP Infringement",
  },
  {
    id: "NUDITY",
    icon: <FadedIcon className="fa-fw" icon={faShieldExclamation} />,
    name: "Nudity",
  },
  {
    id: "VIOLENCE",
    icon: <FadedIcon className="fa-fw" icon={faHandFist} />,
    name: "Violence",
  },
  {
    id: "HATE_SPEECH",
    icon: <FadedIcon className="fa-fw" icon={faMessageExclamation} />,
    name: "Hate Speech",
  },
  {
    id: "SPAM",
    icon: <FadedIcon className="fa-fw" icon={faRepeat} />,
    name: "Spam",
  },
  {
    id: "OTHER",
    icon: <FadedIcon className="fa-fw" icon={faSquareEllipsis} />,
    name: "Other",
  },
];

export default function ReportIcon() {
  return <FontAwesomeIcon className="fa-fw" icon={faFlag} />;
}
